import { Component, OnInit, AfterViewChecked, ViewChild, ViewEncapsulation } from "@angular/core";
import { Product } from "../../../../shared/models/product";
import { SwiperOptions } from 'swiper';
import { MatTabGroup, MatTabChangeEvent } from "@angular/material";
import { ProductsService } from "src/app/services/products.service";
import { CategoryService } from "src/app/services/category.service";
import { max } from "rxjs/operators";
import { element } from "@angular/core/src/render3/instructions";
@Component({
  selector: "app-product-list",
  templateUrl: "./product-list.component.html",
  styleUrls: ["./product-list.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ProductListComponent implements OnInit, AfterViewChecked {
  listGroupCategory: any[] = [];
  listGroupTabCategory: any[] = [];
  hotSale: any;
  productList: Product[];
  innerHeight: number;
  listCategories: any[];
  loading = false;
  hiddenCardLoader = false;
  currentCategory: any;
  freeTrial: String = "free_trial";
  bigSale: String = "big_sale";
  page = 1;
  listType: any[] = [];
  classNameResize = "same-height";

  @ViewChild("WraperSameHeight") wraperSameHeight: any;

  constructor(
    private categoryService: CategoryService,
    private productsService: ProductsService,
  ) { }
  ngAfterViewChecked(): void {
    // this.setHeightAuto(this.wraperSameHeight.nativeElement,this.classNameResize);
  }
  config: SwiperOptions = {
    // pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 3,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    freeMode: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: true,
    loop: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      800: {
        slidesPerView: 2,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1920: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  };
  ngOnInit() {
    this.getAllProducts();
    this.getAllCategories();
  }

  getListType() {
    this.categoryService.getListType().subscribe((data: any) => {
      this.listType = data;
      this.createGroupCategory()
    })
  }

  createGroupCategory() {
    for (let index = 0; index < this.listType.length; index++) {
      var groupProductType: any[] = [];
      this.listCategories.forEach(element => {
        if (element.type + "" === this.listType[index] + "") {
          groupProductType.push(element)
        }
      });
      this.listGroupCategory.push(groupProductType);
    }
    var index = 0;
    while (true) {
      if (this.listGroupCategory[index] === undefined) {
        break;
      }
      var groupTab: any[] = [];
      groupTab.push(this.listGroupCategory[index]);
      index++;
      if (this.listGroupCategory[index] === undefined) {
        break;
      }
      groupTab.push(this.listGroupCategory[index]);
      index++;
      this.listGroupTabCategory.push(groupTab)
    }
    console.log(this.listGroupTabCategory);
  }


  scrollToTop() {
    window.scrollTo(0, 0)
  }



  getAllProducts() {
    this.productsService.search({ size: 1000, isEnable: true }).subscribe((result: any) => {
      this.productList = result.content;
    });
  }
  getAllCategories() {
    this.categoryService.searchCategories({ isEcommerce: false,size: 1000 })
      .subscribe((data: any) => {
        this.listCategories = data.content;
        this.hiddenCardLoader = true;
        this.hotSale = this.listCategories[0]
        this.getListType();
      });
  }
  searchBycategory(categoryId) {
    this.currentCategory = categoryId;
    this.productsService.search({ categoryId: categoryId, size: 1000 }).subscribe((result: any) => {
      this.productList = result.content;
    });
  }




}
